import request from '@/utils/request'
const strUrl = '/store-dev-app'
const commentUrlPrefix = '/store-admin-comment'
    // 查询菜单列表
export default {
    applist(params) {
        return request({
            url: `${strUrl}/app`,
            method: 'get',
            params
        })
    },
    apps(params) {
        return request({
            url: `${strUrl}/report/my-apps`,
            method: 'get',
            params
        })
    },
    downcounts(params) {
        return request({
            url: `${strUrl}/report/my-downcounts`,
            method: 'get',
            params
        })
    },
    comments(params) {
        return request({
            url: `${strUrl}/report/my-comments`,
            method: 'get',
            params
        })
    },
    // 查询数据详情
    getDetailInfo(id) {
        return request({
            url: `${strUrl}/getAppDetail/${id}`,
            method: 'get',
        })
    },
    // 图片上传
    uploadImage(params) {
        return request({
            url: `${strUrl}/uploadPic`,
            method: 'post',
            params
        })
    },
    // 应用分类下拉数据查询
    getCategoryList() {
        // return request({
        //     url: `${strUrl}/getCategoryList`,
        //     method: 'get'
        // })
    },
    // 应用分类下拉数据保存
    updateCategoryId(params) {
        return request({
            url: `${strUrl}/appCategoryId`,
            method: 'put',
            data: params
        })
    },
    // 应用本地化信息保存
    updateAppLanInfo(params) {
        return request({
            url: `${strUrl}/appLanInfo`,
            method: 'put',
            data: params
        })
    },
    //运营标签删除
    deletAppTags(params) {
        return request({
            url: `${strUrl}/appTags`,
            method: 'DELETE',
            data: params
        })
    },
    //运营标签新增
    addAppTags(params) {
        return request({
            url: `${strUrl}/appTags`,
            method: 'post',
            data: params
        })
    },
    //标签修改
    updateappSourceLabe(params) {
        return request({
            url: `${strUrl}/appSourceLabel`,
            method: 'put',
            data: params
        })
    },

    // 应用分类下拉数据保存
    editAppLanInfo(params) {
        return request({
            url: `${strUrl}/editAppLanInfo `,
            method: 'post',
            data: params
        })
    },
    // 应用本地信息查询
    getAppLanInfo(params) {
        return request({
            url: `${strUrl}/getAppLanInfo/${params.appInfoId}/${params.lan}`,
            method: 'get',
        })
    },
    // 历史版本列表
    getAppHistoryList(id, params) {
        return request({
            url: `${strUrl}/app/${id}/history`,
            method: 'get',
            params
        })
    },
    // 审核状态查询
    getAppBundleInfoList(id) {
        return request({
            url: `${strUrl}/app/${id}/audit_status`,
            method: 'get',
        })
    },
    // 下架审核
    getOffShelf(id, params) {
        return request({
            url: `${strUrl}/app/${id}/off_shelf`,
            method: 'post',
            data: params
        })
    },
    //应用删除
    removeApp(id) {
        return request({
            url: `${strUrl}/app/${id}/revoke`,
            method: 'delete'
        })
    },
    //应用撤销
    deletApp(id) {
        return request({
            url: `${strUrl}/app/${id}`,
            method: 'delete'
        })
    },
    // 应用分级修改
    updateAppLevel(params) {
        return request({
            url: `${strUrl}/updateAppLevel`,
            method: 'put',
            data: params
        })
    },
    // 绑定修改、新增
    editAppBundle(params) {
        return request({
            url: `${strUrl}/editAppBundle`,
            method: 'put',
            data: params
        })
    },
    //横屏、竖屏图片保存接口
    appScreenshots(params) {
        return request({
            url: `${strUrl}/appScreenshots`,
            method: 'put',
            data: params
        })
    },
    //历史版本上架
    shelfApp(id) {
        return request({
            url: `${strUrl}/shelfApp/${id}`,
            method: 'post',
            // data: params
        })
    },
    //历史详情
    historyDetail(id) {
        return request({
            url: `${strUrl}/app/${id}/detail`,
            method: 'get',
            // data: params
        })
    },
    changePeo(data) {
        return request({
            url: '/store-dev-auth/sign_agreement',
            method: 'post',
            data: data
        })
    },
    //渠道包列表查詢

    channelAppPkg(appId, params) {
        return request({
            url: `${strUrl}/channelAppPkg/${appId}`,
            method: 'get',
            params
        })
    },
    // 渠道包下架审核
    channelOffShelf(id, params) {
        return request({
            url: `${strUrl}/channelPkgOper/${id}`,
            method: 'post',
            data: params
        })
    },
    //渠道包撤销
    channelDeletApp(id) {
        return request({
            url: `${strUrl}/channelAppPkg/${id}`,
            method: 'delete'
        })
    },
    //指定版本列表
    appSpecificPkg(id,params) {
        return request({
            url: `${strUrl}/appSpecificPkg/${id}`,
            method: 'get',
            params
        })
    },
    //指定版本删除
    delappSpecificPkg(id) {
        return request({
            url: `${strUrl}/appSpecificPkg/${id} `,
            method: 'delete'
        })
    },
    //指定版本删除下架
    appSpecificPkgOper(id,data) {
        return request({
            url: `${strUrl}/appSpecificPkgOper/${id} `,
            method: 'post',
            data:data
        })
    },
    //获取token
    getToken(appid,data) {
        return request({
            url: `${strUrl}/virusLib/token/${appid}`,
            method: 'get',
        })
    },
    // 查看应用名称是否重复
    getAppNameRepeat(params) {
      return request({
          url: `${strUrl}/app/name`,
        method: 'get',
        params
      })
    },
    // 翻译至目标语言
    transformLanguage(data){
        return request({
            url: `${strUrl}/text/translate`,
            method: 'post',
            data
        })
    },
    // 分解json对象，按每个key:value包装为新的json串，迭归提交翻译
    // 这么做的原因是因为翻译接口有时会将key也翻译，以及其他格式问题导致反序列化失败
    async transformLanguageByJson(json, sourceLan, targetLan){
        //翻译接口
        //@params text string
        //@return promise<string>
        const transformer = function(text){
            return new Promise(function(resolve, reject){
                const data = {
                    sourceLan,
                    targetLan,
                    sourceText: JSON.stringify({a: text})
                }
                request({
                    url: `${strUrl}/text/translate`,
                    method: 'post',
                    data
                }).then(result=>{
                    let value = ""
                    if(~~result.status == 200){
                        const info = JSON.parse(result.datas.replace(/\\/g,'').replace(/[0-9|a-z|_]+.{0,1}":/ig,m=>m.toLowerCase()))
                        value = Object.values(info)[0] || ""
                    }
                    resolve(value)
                }).catch(err=>reject(''))
            })
        }
        const createTransformJob = async function(json){
            for(var i in json){
                if(typeof(json[i]) == "string"){
                    const t = await transformer(json[i])
                    console.log(t)
                    json[i] = t
                }else if(json[i] instanceof Object){
                    await createTransformJob(json[i])
                }
            }
        }
        return new Promise(async function(resolve,reject){
            await createTransformJob(json)
            resolve(json)
        })
    },
    // 获得评论列表
    getComments(params){
        return request({
            url: `${commentUrlPrefix}/dev-comment-list`,
            method: 'get',
            params
        })
    },
    // 回复评论
    replyComment(data){
        return request({
            url: `${commentUrlPrefix}/replyDevelop`,
            method: 'post',
            data
        })
    }
}
